import * as React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useAuth } from "oidc-react";
import CompanySelectorButton from "../common/CompanySelectorButton";
import Rendered from "../Rendered";
import ProfileButton from "./ProfileButton";
import LanguageButton from "./LanguageButton";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import ContactInfo from "./ContactInfo";

function NavigationToolbar({ renderMiniMenu }) {
  const auth = useAuth();
  const languageContext = useContext(LanguageContext);

  return (
    <Box sx={{ ...(!renderMiniMenu && { display: "flex", alignItems: "center" }) }}>
      <Rendered rendered={!!auth.userData && !!renderMiniMenu}>
        <CompanySelectorButton renderMiniMenu />
      </Rendered>
      <Rendered rendered={!renderMiniMenu}>
        <ProfileButton />
      </Rendered>
      <Box sx={{ display: "flex", ...(renderMiniMenu && { justifyContent: "center" }) }}>
        <LanguageButton renderMiniMenu={renderMiniMenu} />
        <Tooltip arrow title={languageContext.dictionary.logout}>
          <IconButton sx={{ height: 50, width: 50 }} onClick={() => auth.userManager.signoutRedirect()}>
            <Icon sx={{ color: "secondary.main" }}>{"logout"}</Icon>
          </IconButton>
        </Tooltip>
        <Rendered rendered={!!renderMiniMenu}>
          <ContactInfo mobileView/>
        </Rendered>
      </Box>
    </Box>
  );
}

NavigationToolbar.propTypes = {
  renderMiniMenu: PropTypes.bool
};

export default NavigationToolbar;
